/* ============================================================
   FlickerBet — Scroll Animations & Counters
   ============================================================ */ (function() {
    'use strict';
    // ── Intersection Observer for fade-up ──
    const fadeEls = document.querySelectorAll('.fade-up, .fade-in');
    if (!fadeEls.length) return;
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
    });
    fadeEls.forEach(function(el) {
        observer.observe(el);
    });
    // ── Stat counters ──
    const statEls = document.querySelectorAll('.stat-number[data-target]');
    if (!statEls.length) return;
    const counterObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                counterObserver.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.5
    });
    statEls.forEach(function(el) {
        counterObserver.observe(el);
    });
    function animateCounter(el) {
        const target = parseFloat(el.dataset.target) || 0;
        const suffix = el.dataset.suffix || '';
        const duration = 1800;
        const steps = 60;
        const increment = target / steps;
        let current = 0;
        let step = 0;
        const timer = setInterval(function() {
            step++;
            current = Math.min(current + increment, target);
            // Format output
            let display = '';
            if (Number.isInteger(target)) display = Math.round(current).toString();
            else display = current.toFixed(1);
            el.textContent = display + suffix;
            if (step >= steps) {
                clearInterval(timer);
                el.textContent = target % 1 === 0 ? target.toString() + suffix : target.toFixed(1) + suffix;
            }
        }, duration / steps);
    }
    // ── Mini chart bar random variation ──
    const miniBars = document.querySelectorAll('.mini-bar');
    if (miniBars.length) setInterval(function() {
        miniBars.forEach(function(bar) {
            if (!bar.classList.contains('active')) {
                const h = Math.round(20 + Math.random() * 75);
                bar.style.height = h + '%';
            }
        });
    }, 2000);
})();

//# sourceMappingURL=project-6a06e5c63dd06d7c7d8222d4.315fa9fb.js.map
